module.exports = __webpack_public_path__ + "img/Anniversaire_enfant.79b3148.jpg";